import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MonitorBadge } from './MonitorStatus';

export default function SitesTable({ sites }) {
  var navigate = useNavigate();

  if (!sites || sites.length === 0) {
    return <div className="empty-state"><h3>{'\u05d0\u05d9\u05df \u05d0\u05ea\u05e8\u05d9\u05dd'}</h3><p>{'\u05d4\u05d5\u05e1\u05e3 \u05d0\u05ea \u05d4\u05d0\u05ea\u05e8 \u05d4\u05e8\u05d0\u05e9\u05d5\u05df \u05db\u05d3\u05d9 \u05dc\u05d4\u05ea\u05d7\u05d9\u05dc'}</p></div>;
  }

  var statusConfig = {
    active: { label: '\u05e4\u05e2\u05d9\u05dc', color: 'var(--green)', bg: 'var(--green-glow)' },
    paused: { label: '\u05de\u05d5\u05e9\u05d4\u05d4', color: 'var(--orange)', bg: 'var(--orange-glow)' },
    frozen: { label: '\u05de\u05d5\u05e7\u05e4\u05d0', color: 'var(--text-muted)', bg: 'var(--surface-hover)' },
  };

  var healthColors = { green: 'green', yellow: 'yellow', red: 'red' };
  var healthLabels = { green: '\u05ea\u05e7\u05d9\u05df', yellow: '\u05d0\u05d6\u05d4\u05e8\u05d4', red: '\u05e7\u05e8\u05d9\u05d8\u05d9' };

  function healthReason(site) {
    var kw = site.keywords_count || 0;
    if (!kw) return '\u05d0\u05d9\u05df \u05de\u05d9\u05dc\u05d5\u05ea \u05de\u05e4\u05ea\u05d7 \u05d1\u05de\u05e2\u05e7\u05d1';
    var nr = site.not_ranked || 0;
    var pct = Math.round((nr / kw) * 100);
    var trend = (site.improved || 0) + ' \u05e2\u05dc\u05d5 / ' + (site.declined || 0) + ' \u05d9\u05e8\u05d3\u05d5';
    return nr + ' \u05de\u05ea\u05d5\u05da ' + kw + ' \u05d1\u05d9\u05d8\u05d5\u05d9\u05d9\u05dd \u05dc\u05d0 \u05de\u05d3\u05d5\u05e8\u05d2\u05d9\u05dd (' + pct + '%) \u00b7 ' + trend;
  }

  return (
    <div className="sites-table-wrapper animate-in">
      <table className="sites-table">
        <thead>
          <tr>
            <th>{'\u05d0\u05ea\u05e8'}</th>
            <th>{'\u05de\u05e7\u05d3\u05dd'}</th>
            <th>{'\u05de\u05d9\u05e7\u05d5\u05dd \u05de\u05de\u05d5\u05e6\u05e2'}</th>
            <th>{'\u05d1\u05e2\u05de\u05d5\u05d3 \u05e8\u05d0\u05e9\u05d5\u05df'}</th>
            <th>{'\u05d1\u05d9\u05d8\u05d5\u05d9\u05d9\u05dd'}</th>
            <th>{'\u05d1\u05e8\u05d9\u05d0\u05d5\u05ea'}</th>
            <th>{'\u05e0\u05d9\u05d8\u05d5\u05e8'}</th>
            <th>{'\u05e1\u05d8\u05d8\u05d5\u05e1'}</th>
          </tr>
        </thead>
        <tbody>
          {sites.map(function(site) {
            var st = statusConfig[site.status] || statusConfig.active;
            var isFrozen = site.status === 'frozen';

            return (
              <tr
                key={site.id}
                onClick={function() { navigate('/sites/' + site.id); }}
                style={isFrozen ? { opacity: 0.55 } : undefined}
              >
                <td>
                  <div className="site-name-cell">
                    <div className="site-favicon">{(site.name || '?').charAt(0).toUpperCase()}</div>
                    <div className="site-info-cell">
                      <div className="site-domain">{site.name}</div>
                      <div className="site-client" style={{direction:'ltr',textAlign:'right'}}>
                        {site.url ? site.url.replace(/^https?:\/\//, '') : ''}
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  {site.assigned_to ? (
                    <span className="promoter-tag">{site.assigned_to}</span>
                  ) : (
                    <span style={{color:'var(--text-muted)', fontSize: '12px'}}>-</span>
                  )}
                </td>
                <td>
                  {site.avg_position ? (
                    <span className="metric-val">{site.avg_position}</span>
                  ) : (
                    <span style={{color:'var(--text-muted)'}}>-</span>
                  )}
                </td>
                <td>
                  {site.top10 != null ? (
                    <span className="metric-val">{site.top10}</span>
                  ) : (
                    <span style={{color:'var(--text-muted)'}}>-</span>
                  )}
                </td>
                <td>
                  <span className="metric-val">{site.keywords_count || 0}</span>
                </td>
                <td>
                  <div className="health-indicator" title={healthReason(site)}>
                    <div className={'health-dot ' + (healthColors[site.health] || 'yellow')} />
                    <span className="health-label">{healthLabels[site.health] || '\u05dc\u05d0 \u05d9\u05d3\u05d5\u05e2'}</span>
                  </div>
                </td>
                <td onClick={function(e) { e.stopPropagation(); }}>
                  <MonitorBadge site={site} />
                </td>
                <td>
                  <span className="change-badge" style={{
                    color: st.color,
                    background: st.bg,
                  }}>{st.label}</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
